export default {
  primary: {
    main: "#8bc34a",
    light: "#9ccc65",
    contrastText: "#fff"
  }
};
//# sourceMappingURL=lightGreen.js.map